import { rowsFromQaLog } from "./qa-check-rows";
import { audioSeed, groupRows, highlightSeed, qaSeed, statusTally } from "./summary-group";
import { audioOf, highlightOf, hourLabels, hourOf, qaOf, readField, surveyorOf } from "./summary-read";

const byHour = (rows) => {
    const map = new Map();

    rows.forEach((row) => {
        const date = readField(row, "dt_month_date");
        if (!date) return;

        if (!map.has(date)) {
            const bucket = { dt_month_date: date };
            hourLabels.forEach((hour) => {
                bucket[`hr_${hour}`] = 0;
            });
            map.set(date, bucket);
        }

        const hour = hourOf(row);
        if (hour) map.get(date)[hour] += 1;
    });

    return Array.from(map.values());
};

const qaRows = (rows) =>
    rows.map((row) => ({
        ...row,
        qalog: row?.qalog || row?.qa?.qalog,
        qa_status: row?.qa_status || row?.qa?.qa_status,
    }));

const builtSummary = (rows) => {
    const list = rows || [];
    const person = (row) => surveyorOf(row);
    const date = (row) => readField(row, "dt_month_date");
    const level1 = (row) => readField(row, "piv_level1");
    const level2 = (row) => readField(row, "piv_level2");

    return {
        by_surveyor_qa: groupRows(list, (row) => person(row).surveyor_id, (row) => qaSeed(person(row)), qaOf),
        by_date_qa: groupRows(list, date, (row) => qaSeed({ dt_month_date: date(row) }), qaOf),
        by_piv_level1_qa: groupRows(list, level1, (row) => qaSeed({ piv_level1: level1(row) }), qaOf),
        by_piv_level2_qa: groupRows(list, level2, (row) => qaSeed({ piv_level2: level2(row) }), qaOf),
        by_surveyor_audio: groupRows(list, (row) => person(row).surveyor_id, (row) => audioSeed(person(row)), audioOf),
        by_piv_level1_audio: groupRows(list, level1, (row) => audioSeed({ piv_level1: level1(row) }), audioOf),
        by_piv_level2_audio: groupRows(list, level2, (row) => audioSeed({ piv_level2: level2(row) }), audioOf),
        by_surveyor_hl: groupRows(list, (row) => person(row).surveyor_id, (row) => highlightSeed(person(row)), highlightOf),
        by_piv_level1_hl: groupRows(list, level1, (row) => highlightSeed({ piv_level1: level1(row) }), highlightOf),
        by_piv_level2_hl: groupRows(list, level2, (row) => highlightSeed({ piv_level2: level2(row) }), highlightOf),
        by_date_hl: groupRows(list, date, (row) => highlightSeed({ dt_month_date: date(row) }), highlightOf),
        by_dt_month_hour: byHour(list),
        by_qa_status: statusTally(list, qaOf, ["valid", "invalid", "not-checked"]),
        by_hasaudio: statusTally(list, audioOf, ["has audio", "no audio"]),
        by_qalog_user_status: rowsFromQaLog(qaRows(list)),
        by_piv_level2_surveyor_id_qa_status: groupRows(
            list,
            (row) => [person(row).surveyor_id, level2(row), date(row)].join("|"),
            (row) => qaSeed({ ...person(row), piv_level2: level2(row), dt_month_date: date(row) }),
            qaOf
        ),
    };
};

export const fillNullSummary = (summary, rows) => {
    const next = { ...(summary || {}) };
    const built = builtSummary(rows);

    Object.keys(built).forEach((key) => {
        const current = next[key];
        const missing = !Array.isArray(current) || current.length === 0;
        if (missing && built[key].length) next[key] = built[key];
    });

    return next;
};
